import { useEffect, useState } from "react";
import classNames from "classnames";
import { Visible } from "util/enhancer";

type AccordionProps = {
  header: string | React.ReactNode;
  id?: number;
  children?: React.ReactNode;
  className?: string;
  open?: boolean;
  disabled?: boolean;
  onOpen?: (id: number) => void;
};

export const Accordion: React.FC<AccordionProps> = (props: AccordionProps) => {
  const {
    id,
    className,
    children,
    header,
    disabled,
    onOpen = () => {},
  } = props;
  const [open, setOpen] = useState(props.open ?? false);
  const extraClass = className || "";
  const activeClass = open ? "accordion-border" : "";

  useEffect(() => {
    setOpen(!!props.open);
  }, [props.open]);

  const handleOnClick = () => {
    onOpen(id!);
    setOpen(!open);
  };

  return (
    <section className={`accordion ${extraClass}`.trim()}>
      <div
        className={classNames(`${activeClass}`, {
          active: open,
        })}
      >
        <button
          className="accordion-header"
          disabled={disabled}
          aria-expanded={open}
          tabIndex={0}
          onClick={handleOnClick}
        >
          {getAccordionHeader(header, extraClass)}
          <div className="arrow-container">
            <div
              className={open ? "arrow up icon-color" : "arrow down icon-color"}
            />
          </div>
        </button>
      </div>
      {!disabled && open && <div className="accordion-body">{children}</div>}
    </section>
  );
};

function getAccordionHeader(
  header: string | React.ReactNode,
  className: string
) {
  if (className === "kp-accordion") {
    return header;
  }

  return <div className="zb-heading3 accordion-header-title">{header}</div>;
}

export const VisibleAccordion = Visible(Accordion);
